import { createFileRoute } from '@tanstack/react-router'

import { guardScreen } from '@/app/route-guards'
import { TranslatingScreen } from '@/features/steps'

export const Route = createFileRoute('/_auth/documents/$docId/translating')({
  beforeLoad: ({ context, params }) => guardScreen(context.queryClient, params.docId, 'translating'),
  component: TranslatingRoute,
})

function TranslatingRoute() {
  const { docId } = Route.useParams()
  return <TranslatingScreen docId={docId} />
}
